"use client";

import { useRecommendedSeries } from "app/hooks";
import { SeriesBox } from "./SeriesBox";

export function SeriesRecommendedSeries({ seriesHash }: { seriesHash: string }) {
  const { results } = useRecommendedSeries(seriesHash);
  const recommendedSeries = results?.recommendedSeries;

  if (recommendedSeries?.length) {
    return (
      <div className="series-recommend">
        <h2 className="series-recommend-h">この作品を読んだ人におすすめ！</h2>
        <div className="series-list mode-recommend">
          {recommendedSeries.map((item, index) => {
            const imgId = item.images?.length ? item.images[0].id : undefined;
            return (
              <SeriesBox displayedOn="series" series={item} displayIndex={index} key={index} />
            );
          })}
        </div>
      </div>
    );
  } else {
    return <></>;
  }
}
